import { find } from 'lodash-es';
import type { SortBy } from 'tea-component/lib/table/addons';
import type { TFileLibraryQuery, TFileLibrarySort, TFileLibrarySortKey } from '../types';

const SORTABLE_KEYS: TFileLibrarySortKey[] = [
  'file_name',
  'created_at',
  'file_size',
];

/**
 * 当前生效筛选数量（文件类型 / 时间 / 来源）
 * @param query - 含 fileType、timeRange、source 的查询片段
 */
export const getActiveFilterCount = (
  query: Pick<TFileLibraryQuery, 'fileType' | 'timeRange' | 'source'>,
): number =>
  [query.fileType, query.timeRange, query.source].filter(Boolean).length;

/**
 * 页面 sort 转 tea Table SortBy
 * @param sort - 文件库排序状态
 */
export const getSortInfoFromQuery = (
  sort: TFileLibrarySort,
): SortBy<string> => ({
  by: sort.key,
  order: sort.asc ? 'asc' : 'desc',
});

/**
 * tea Table SortBy 转文件库 sort
 * @param value - 表格排序回调值
 */
export const getSortFromTableSort = (value: SortBy<string>): TFileLibrarySort => ({
  key: find(SORTABLE_KEYS, item => item === value.by) || 'created_at',
  asc: value.order === 'asc',
});

/** 表格可排序列 key 列表 */
export const FILE_LIBRARY_SORTABLE_COLUMNS = SORTABLE_KEYS;
